/**
 * A safe wrapper for localStorage to prevent SecurityError exceptions
 * when storage is blocked (e.g., in private mode or due to browser settings).
 */
const isStorageAvailable = (): boolean => {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return false;
    const testKey = '__storage_test__';
    window.localStorage.setItem(testKey, testKey);
    window.localStorage.removeItem(testKey);
    return true;
  } catch (e) {
    return false;
  }
};

const storageAvailable = isStorageAvailable();

export const safeStorage = {
  getItem: (key: string): string | null => {
    if (!storageAvailable) return null;
    try {
      return window.localStorage.getItem(key);
    } catch (e) {
      console.warn(`[safeStorage] Failed to getItem for key "${key}":`, e);
      return null;
    }
  },
  setItem: (key: string, value: string): void => {
    if (!storageAvailable) return;
    try {
      window.localStorage.setItem(key, value);
    } catch (e) {
      console.warn(`[safeStorage] Failed to setItem for key "${key}":`, e);
    }
  },
  removeItem: (key: string): void => {
    if (!storageAvailable) return;
    try {
      window.localStorage.removeItem(key);
    } catch (e) {
      console.warn(`[safeStorage] Failed to removeItem for key "${key}":`, e);
    }
  },
  clear: (): void => {
    if (!storageAvailable) return;
    try {
      window.localStorage.clear();
    } catch (e) {
      console.warn(`[safeStorage] Failed to clear storage:`, e);
    }
  }
};
